var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"stroke":"#000","strokeWidth":"2"},React.createElement("path",{"d":"M1355 369L1376 390 1355 411","transform":"translate(-1354 -368)"}))));
}

ChevronRight.defaultProps = {"width":"24","height":"44","viewBox":"0 0 24 44"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
